
import { IAxeConsumer } from 'src/integration/api/ui/FeedbackProvider';
import { II18n } from 'src/integration/api/ui/Ui';
import { AllyDI } from 'src/integration/di/DI';
import * as NullUtil from 'src/shared/NullUtil';

import { IEditorListener } from './IEditorListener';
import { WysiwygFeedbackController } from './WysiwygFeedbackController';
import { IBaseFeedback } from './WysiwygFeedbackUtil';

const { FileReference } = require('src/integration/api/client/FileReference');
const AllyIntegrationUtil = require('src/integration/util');
const AllyConfig = require('src/shared/rest/Config');
const AllyFacade = require('src/shared/rest/facade');

/**
 * Implementation of the WysiwygFeedbackController that runs on integration platforms that use non-public integration
 * API code (i.e., JS code with facade.js/ally-rest.js for issuing web requests).
 */
export class LegacyWysiwygFeedbackController extends WysiwygFeedbackController {
    constructor(
        baseUrl: string,
        courseId: string,
        locale: string,
        i18n: II18n,
        listener: IEditorListener,
        feedbackContainer?: HTMLElement
    ) {
        super(
            baseUrl,
            AllyConfig.lmsType(),
            locale,
            i18n,
            listener,
            {
                'closeInstructorFeedback': () => AllyIntegrationUtil.closeInstructorFeedback(),
                'generateHtmlFeedback': async (html) => {
                    const di = await AllyDI.get();
                    const consumer = {
                        'consume': (input: JSON) => new Promise<IBaseFeedback>((resolve, reject) => {
                            return AllyFacade.generateAxeFeedback(
                                input,
                                (err: any, response: IBaseFeedback) =>
                                    NullUtil.hasValue(err) ? reject(err) : resolve(response)
                            );
                        }),
                        'preprocessType': AllyConfig.lmsType()
                    } as IAxeConsumer;
                    return di.feedbackProviderFactory.provide(consumer).feedback(html);
                },
                'launchInstructorFeedback': (opts, callbacks) => {
                    AllyIntegrationUtil.launchInstructorFeedback(
                        courseId,
                        new FileReference('content:irrelevant', {}, 'RichContent'),
                        opts,
                        callbacks
                    );
                },
                'updateLiveFeedback': (liveFeedback) => AllyIntegrationUtil.updateLiveFeedback(liveFeedback),
                'updateLiveFeedbackContent': (content) => AllyIntegrationUtil.updateLiveFeedbackContent(content)
            },
            feedbackContainer
        );
    }
}
